import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "影评", to: "/category/review" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-site items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-lg text-background-50">
            <i className="ri-movie-2-line" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-primary-800">亚洲天堂</span>
            <span className="hidden text-[10px] uppercase tracking-[0.2em] text-foreground-400 sm:block">
              ASIA CINEMA
            </span>
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                isActive(link.to)
                  ? "text-accent-600"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden md:block">
          <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 transition-colors focus-within:border-primary-400 focus-within:bg-background-50">
            <i className="ri-search-line text-base text-foreground-400" aria-hidden="true"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影片、影评…"
              aria-label="站内搜索"
              className="w-28 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none lg:w-44"
            />
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-lg text-foreground-700 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={handleSearch} className="mb-3">
            <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-400" aria-hidden="true"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、影评…"
                aria-label="站内搜索"
                className="w-full text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
          </form>
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive(link.to) ? "bg-accent-50 text-accent-700" : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}